import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const InvalidBox = styled.div`
  background: ${({ theme: { colors } }) => colors.red_3};
  border-radius: 0 0 14px 14px;
  padding: ${pxToRem(10)} ${pxToRem(20)};
  margin: ${pxToRem(-30)};
  margin-top: ${pxToRem(10)};
  transition: 0.2s ease-out;
  svg {
    width: 15px;
    height: 15px;
  }
`;

export const Button = styled.button`
  cursor: pointer;
  padding: 0;
  svg {
    width: ${pxToRem(12)};
    height: ${pxToRem(12)};
    transition: 0.2s;
    transform: ${({ isActive }) => (isActive ? 'rotate(-90deg)' : 'rotate(90deg)')};
  }
`;

export const ErrorsList = styled.ul`
  list-style: disc;
  margin-left: ${pxToRem(41)};
  margin-top: ${pxToRem(14)};
  li {
    font-size: ${pxToRem(14)};
  }
  li:not(:last-child) {
    margin-bottom: ${pxToRem(20)};
  }
`;
